import React, {Component} from "react";
import PropTypes from "prop-types";

import {cloneDeep, remove} from "lodash";

import {
    Input,
    Spinner,
    Dropdown,
    DropdownMenu,
} from "reactstrap";
//classes
import WbSession from "classes/Session.jsx";

class AbnField extends Component {
    static contextType = WbSession;
    
    debug = false;
    state = {
        currentValue: '',
        lastLookup: '',
        searchResults: [],
        hasMore: false,
        hasFocus: false
    };
    fieldTimeout = {};
    blurTimeout = {};
    
    constructor( props ){
        super( props );
        this.state.currentValue = this.props.value ?? '';
    }
    
    lookup_abr = async () => {
        const { currentValue, lastLookup } = this.state;
        
        const abnValue = currentValue ?? '';
        const lookup = abnValue.replace(' ','').trim();
        
        if( lookup.length > 5 && lastLookup != lookup ){
            this.setState({loadingAbn:true,searchResults:[]});
            const data = await this.context.lookupAbn( lookup );
            
            if( data.success && typeof data.entity_data != "undefined" ){
                let results = data.entity_data ?? [];
                if( typeof results[Symbol.iterator] !== 'function' ){ // if is not an iterable array (ie. only one result)
                    results = [ results ]; // add this result into an array
                }
                this.setState({
                    loadingAbn: false,
                    lastLookup: lookup,
                    searchResults: results,
                    hasMore: ('Y'==data.entity_data.exceedsMaximum),
                });
            } else {
                this.setState({
                    loadingAbn: false,
                    lastLookup: '',
                    searchResults: [],
                    hasMore: false,
                });
            }
        } else {
            this.setState({
                loadingAbn: false,
                lastLookup: '',
                searchResults: [],
                hasMore: false,
            });
        }
    };
    
    formatAbn = ( newAbn ) => {
        const inputStr = newAbn.replaceAll(" ","").trim();
        let newStr = " ";
        let len = inputStr.length;
        for (let i = 0; i<len; i++) {
            newStr = newStr + inputStr[i];
            if( // Add spaces to format xx xxx xxx xxx
                3 == newStr.length ||
                7 == newStr.length ||
                11 == newStr.length
            ) {
                newStr = newStr + " ";
            }
        }
        
        newStr = newStr.trim();
        
        if( newStr.length > 14 ){ // 11 digits, plus 3 spaces
            newStr = newStr.substring(0, 14);
        }
        
        return newStr;
    };
    
    render(){
        const {
            fldId,
            value,
            placeholder,
            onChange,
            error,
            readonly,
        } = this.props;
        
        const {
            loadingAbn,
            searchResults,
            hasMore,
            hasFocus,
            currentValue,
        } = this.state;
        
        let fldClass = '';
        if( readonly ){
            fldClass += ' form-control-muted';
        }
        
        return (
            <>
                <Dropdown
                    direction="down"
                    isOpen={hasFocus&&(searchResults.length||loadingAbn)}
                    className="abnField"
                    onFocus={e=>{
                        clearTimeout(this.blurTimeout);
                        this.setState({hasFocus:true});
                    }}
                    onBlur={e=>{
                        clearTimeout(this.blurTimeout);
                        this.blurTimeout = setTimeout( e=>{
                            this.setState({hasFocus:false});
                        }, 600 );
                    }}
                >
                    <Input
                        id={'meta_'+fldId}
                        type="text"
                        value={value}
                        placeholder={placeholder}
                        onChange={(e)=>{
                            let newStr = e.target.value ?? '';
                            const formattedAbn = this.formatAbn( newStr );
                            
                            clearTimeout(this.fieldTimeout);
                            this.fieldTimeout = setTimeout( this.lookup_abr, 600 );
                            this.setState({currentValue: formattedAbn});
                            onChange( formattedAbn );
                        }}
                        autocomplete="off"
                        invalid={error}
                        className={fldClass}
                    />
                    <DropdownMenu>
                        {loadingAbn?(
                            <div className="text-center">
                        		<Spinner color="primary" />
                        	</div>
                        ):(
                            <>
                            {searchResults.map(res=>{
                                if( this.debug ) console.log('Looping ABR record: ',res);
                                const business = res.mainName ?? res.businessName ?? res.mainTradingName ?? res.mainName ?? res.legalName ?? null;
                                if( null == business ){
                                    //console.log('Failed to parse business: ',res);
                                    return null;
                                }
                                
                                const orgName = business.organisationName ?? business.fullName ?? '';
                                const orgNameUpper = orgName.toUpperCase();
                                const formattedAbn = this.formatAbn( res.ABN.identifierValue??'' );
                                //console.log('Organisation Name, ',orgName);
                                return (
                                    <div
                                        key={formattedAbn}
                                        onClick={e=>{
                                            if( this.debug ) console.log('Set Entity value', res);
                                            const otherValues = {
                                                'entity': orgNameUpper
                                            };
                                            onChange( currentValue, otherValues );
                                            this.setState({hasFocus:false});
                                        }}
                                    >
                                        {orgNameUpper} ({formattedAbn})
                                    </div>
                                );
                            })}
                            </>
                        )}
                    </DropdownMenu>
                </Dropdown>
            </>
        );
    }
}

AbnField.propTypes = {
    fldId: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    placeholder: PropTypes.string,
    readonly: PropTypes.bool,
    error: PropTypes.bool,
    onChange: PropTypes.func
};

AbnField.defaultProps = {
    fldId: null,
    value: null,
    placeholder: null,
    readonly: null,
    error: false,
    onChange: (newVal) => {console.log('Field value updated',newVal)}
}

export default AbnField;
